import React from 'react';
import PropTypes from 'prop-types';
import {List, Map} from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {Link} from 'react-router';
import {GuideLevelModelV2} from 'resources/augmented/GuideLevel/GuideLevelModel.v2';
import MasteryFlag from 'generic/MasteryFlag/MasteryFlag.react';
import makeRef from 'lib/makeRef';
import Tooltip from 'generic/FixedTooltip/FixedTooltip.react';
import MarkdownRendererV2 from 'generic/MarkdownRendererV2/MarkdownRendererV2.react';
import createLocalStore from 'lib/decorators/createLocalStore';
import {stats} from 'lib/StatsUtil';
import '../topic-listing.scss';

const maxTopicNumber = 3;
export default class Topics extends React.Component {
  static propTypes = {
    heading: PropTypes.string,
    topics: ImmutablePropTypes.list
  };

  getTopicList() {
    const topicSize = this.props.topics.size;

    let placeHolders = new List();
    for (let i = 0; i < maxTopicNumber - topicSize; i++) {
      placeHolders = placeHolders.push(
        <div className='topic-list-row' key={i}>
          <div className='topic-list-row__name topic-list-row__name--no-data topic-list-row-item'>
            No Data Available
          </div>
          <div className='topic-list-row__accuracy topic-list-row__accuracy--no-data topic-list-row-item'>
            N/A
          </div>
          <div className='topic-list-row__mastery topic-list-row__mastery--no-data topic-list-row-item'>
            N/A
          </div>
        </div>
      );
    }

    // {placeHolders} ensures we always have at least 3 things in our card
    return (
      <div className='topic-list'>
        {this.props.topics.map((topic) => {
          const accuracy = stats.toFixed(topic.getMetaStudentAccuracy());
          return (
            <TopicItem
              key={topic.getId()}
              topic={topic}
              accuracy={accuracy}
              storeName={`topic-stats-${this.props.heading}-${topic.getId()}`}
            />
          );
        })}
        {placeHolders}
      </div>
    );
  }

  getEmptyTopicList() {
    return (
      <div className='topic-list topic-list--empty'>
        <div className='topic-list__empty-message'>No data available</div>
      </div>
    );
  }

  render() {
    return (
      <div>
        <h4 className='topic-list-heading'>{this.props.heading}</h4>
        {this.props.topics.isEmpty() ? this.getEmptyTopicList() : this.getTopicList()}
      </div>
    );
  }
}

@createLocalStore(
  new Map({
    isOverflowing: false
  })
)
class TopicItem extends React.Component {
  static propTypes = {
    topic: PropTypes.instanceOf(GuideLevelModelV2).isRequired,
    accuracy: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    this.makeRef = makeRef.bind(this);
    this.refName = `${this.props.topic.getName()}-name-ref`;
  }

  componentDidMount() {
    const ref = this[this.refName];
    const refParent = ref.parentElement;
    const isOverflowing = ref.clientWidth > refParent.clientWidth;

    if (isOverflowing) {
      this.setIsOverflowing();
    }
  }

  setIsOverflowing = () => {
    this.props.setProperty('isOverflowing', true);
  };

  render() {
    const isOverflowing = this.props.store.get('isOverflowing'); // read from store for element name

    let tooltip;
    if (isOverflowing) {
      tooltip = (
        <Tooltip type='white' style={{whiteSpace: 'normal'}}>
          <MarkdownRendererV2 text={this.props.topic.getName()} />
        </Tooltip>
      );
    }
    const {topic} = this.props;
    return (
      <div className='topic-list-row'>
        <div className='topic-list-row__name topic-list-row-item'>
          <div
            className='topic-list-row__name-actual'
            ref={this.makeRef}
            data-ref-name={this.refName}
          >
            <Link to={`/learn/${topic.getSubject().getUrlSlug()}/${topic.getUrlSlug()}`}>
              <MarkdownRendererV2 text={topic.getName()} />
            </Link>
            {tooltip}
          </div>
        </div>
        <div className='topic-list-row__accuracy topic-list-row-item'>
          {this.props.accuracy}% accuracy
        </div>
        <div className='topic-list-row__mastery topic-list-row-item'>
          <MasteryFlag accuracy={this.props.accuracy} hasStarted />
        </div>
      </div>
    );
  }
}
